import React, { useEffect, useState, useContext } from 'react'
import './Settings.css'
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt } from '@iconscout/react-unicons'
import Globalcontext from '../../Context/Globalcontext';
import { useTranslation } from "react-i18next";

const Settings = (props) => {
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({
        mhvah: "", gayvah: "", mhthev: "", gaythev: "",
        kapatbill: "", hptabill: "", ikapatliter: "", ikapatbill: "",
        mhcomm: "", gaycomm: ""
    });
    const [newrow, setNewrow] = useState({
        rowno: "", mhvah: "", gayvah: "", mhthev: "", gaythev: "",
        kapatbill: "", hptabill: "", ikapatliter: "", ikapatbill: ""
    });

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);

    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [value, setValue] = useState('');
    const [rowindexmain, setrowindexmain] = useState(0);
    const { submenu, setsubmenu, setHeadname } = useContext(Globalcontext);
    const [colindexmain, setcolindexmain] = useState(0);
    const [mainvalue, setmainvalue] = useState(0);

    const [t] = useTranslation();

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }))
    }

    const openkapatmaster = (flag) => {
        setsubmenu("kapatmaster");
        setHeadname(t("settings.head.kapat_master"));
    };

    useEffect(() => {
        getcustomers();
        getsettings();
    }, [])

    async function opensr(sr) {
        localStorage.setItem("glcustsr", sr);
        props.setsubmenu("customer");
    }

    async function getcustomers() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getaccoounttemp.php',
            { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
        ).then(function sample(response) {

            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getsettings() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getsettings.php',
            { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
        ).then(function sample(response) {

            if (response.data) {
                response.data.map((user, index) =>
                (
                    setInput({
                        mhvah: user.mhvah,
                        gayvah: user.gayvah,
                        mhthev: user.mhthev,
                        gaythev: user.gaythev,
                        kapatbill: user.kapatbill,
                        hptabill: user.hptabill,
                        ikapatliter: user.ikapatliter,
                        ikapatbill: user.ikapatbill,
                        mhcomm: user.mhcomm,
                        gaycomm: user.gaycomm
                    })
                ))
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const savesettings = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);

        // ✅ Only UI msg translated
        if (
            input.mhvah === "" || input.mhthev === "" || input.gaythev === "" ||
            input.kapatbill === "" || input.hptabill === "" ||
            input.ikapatliter === "" || input.ikapatbill === "" ||
            input.mhcomm === "" || input.gaycomm === ""
        ) {
            notifyerror(t("settings.toast.fill_all"));
        }
        else {
            // ✅ keep server keys & values as-is
            let rawData = {
                mainuser: localStorage.getItem("contact"),
                mhvah: input.mhvah,
                gayvah: input.gayvah,
                mhcomm: input.mhcomm,
                gaycomm: input.gaycomm,
                mhthev: input.mhthev,
                gaythev: input.gaythev,
                kapatbill: input.kapatbill,
                hptabill: input.hptabill,
                ikapatliter: input.ikapatliter,
                ikapatbill: input.ikapatbill,
                mainuser2: mainuser2,
            }
            rawData = JSON.stringify(rawData)

            let formData = new FormData()
            formData.append('data', rawData)

            axios.post('https://excellentdairy.com/dairy/php/cust/savesettings2.php', formData, {
                'Content-Type': 'multipart/form-data',
            }).then(function sample(response) {

                // ✅ keep server response string as-is
                if (response.data.trim() === "Successfully updated.") {
                    notify(t("settings.toast.applied"));
                    getcustomers();
                }

            }).catch(err => {
                console.log(err);
            });
        }
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <div className="settingmain">
            <div className="firstrow">
                <img onClick={props.visibility} className='back' src={back} alt="" />
            </div>

            <div className="firstrow">
                <span>{t("settings.title.apply_all_members")}</span>
            </div>

            <div className="firstrow">
                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.buffalo_deposit_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="mhthev"
                            name="mhthev"
                            value={input.mhthev}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.advance_installment_per_bill")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="kapatbill"
                            name="kapatbill"
                            value={input.kapatbill}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.other_deduction_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="ikapatliter"
                            name="ikapatliter"
                            value={input.ikapatliter}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.buffalo_transport_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="mhvah"
                            name="mhvah"
                            value={input.mhvah}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.buffalo_commission_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="mhcomm"
                            name="mhcomm"
                            value={input.mhcomm}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>
            </div>

            <div className="firstrow">
                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.cow_deposit_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="gaythev"
                            name="gaythev"
                            value={input.gaythev}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.feed_installment_per_bill")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="hptabill"
                            name="hptabill"
                            value={input.hptabill}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{localStorage.getItem("itrmainname") + " /" + t("settings.labels.per_bill")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="ikapatbill"
                            name="ikapatbill"
                            value={input.ikapatbill}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.cow_transport_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="gayvah"
                            name="gayvah"
                            value={input.gayvah}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>

                <div className="mb-2 mx-2 bb">
                    <span className='subhead'>{t("settings.labels.cow_commission_per_liter")}</span>
                    <div className="selection">
                        <input
                            className="form-control centered-input editmode"
                            id="gaycomm"
                            name="gaycomm"
                            value={input.gaycomm}
                            onChange={handleChange}
                            type="number"
                            step="0.1"
                            autoComplete='off'
                        />
                    </div>
                </div>
            </div>

            <div className="mb-2 mx-2 bb">
                <div className='horirow'>
                    <button onClick={savesettings} className='button'>
                        {t("settings.buttons.apply_all")}
                    </button>
                    <div className='vlinesettings' />
                    <button onClick={openkapatmaster} className='button'>
                        {t("settings.buttons.kapat_master")}
                    </button>
                </div>
            </div>

            <div className="table-containersettings">
                <table id="myTable" className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">{t("settings.table.account_no")}</th>
                            <th scope="col">{t("settings.table.name")}</th>
                            <th scope="col">{t("settings.table.buffalo_deposit")}</th>
                            <th scope="col">{t("settings.table.cow_deposit")}</th>
                            <th scope="col">{t("settings.table.advance_installment")}</th>
                            <th scope="col">{t("settings.table.feed_installment")}</th>
                            <th scope="col">{t("settings.table.other_per_liter")}</th>
                            <th scope="col">{t("settings.table.other_per_bill")}</th>
                            <th scope="col">{t("settings.table.buffalo_transport")}</th>
                            <th scope="col">{t("settings.table.cow_transport")}</th>
                            <th scope="col">{t("settings.table.action")}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {(value.length > 0 ? tableFilter : DataSource).map((user, index) =>
                            <tr key={index}>
                                <td>{user.kno}</td>
                                <td>{user.cname}</td>
                                <td>{user.mhthev}</td>
                                <td>{user.gaythev}</td>
                                <td>{user.kapatbill}</td>
                                <td>{user.hptabill}</td>
                                <td>{user.ikapatliter}</td>
                                <td>{user.ikapatbill}</td>
                                <td>{user.mhvah}</td>
                                <td>{user.gayvah}</td>
                                <td>
                                    <UilEditAlt onClick={() => { opensr(user.kno) }} className="icsettings" />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <ToastContainer />
        </div>
    )
}

export default Settings;
